import { render } from "./BsCard.vue?vue&type=template&id=50ffab5c"
import script from "./BsCard.vue?vue&type=script&lang=js"
export * from "./BsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__